import { API_AUTH, setTokenGlobal } from "./common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}

const DatHangDaiLyApi = {
  list: ({
    username,
    tensanpham,
    nhomsanphamId,
    hashtag,
    branchId,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `congthucsanpham/getDanhSachSanPhamDaiLy?username=${username}&tensanpham=${tensanpham}&nhomsanphamId=${nhomsanphamId}&hashtag=${hashtag}&branchId=${branchId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    ),
  listNhomSanPham: (iBranch) => {
    return API_AUTH.get(
      `congthucsanpham/getDanhMucGroupCategories?iBranch=${iBranch}`,
      {},
    );
  },
  listHashtag: () => {
    return API_AUTH.get(`congthucsanpham/combostatushashtag`, {});
  },
  addOrUpdateDatHang: (params) =>
    API_AUTH.post(
      "dathang/addOrUpdateDatHang?sUserName=" + params.sUserName,
      params,
    ),
  listGiaoDich: (customerId, tungay, denngay, pageIndex, pageSize) => {
    return API_AUTH.get(
      `khachhang/chitietthongtincongnokhachhang?customerId=${customerId}&tungay=${tungay}&denngay=${denngay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    );
  },
};

export default DatHangDaiLyApi;
